/**
 * 文字列の改行コードを削除
 * @param text 改行文字を削除する対象の文字列
 * @returns 改行文字がすべて削除された結果の文字列
 */
export const newLineCodeDelete = (text: string) =>
  text.replace(/(\r\n|\n|\r|<br>)/g, '');
